module.exports = __webpack_public_path__ + "static/media/icon-arrow-up-gray.b3fe3bfb.svg";